// SangatiCard.tsx - Sangati Audio Card Component
//
// This component renders the main Sangati card.
// It displays the Sangati logo, title, description
//
// Features:
// - Responsive design with semantic Tailwind classes
// - Internationalization support
// - Accessible design with proper ARIA labels and focus states
//
// Usage:
// <div className="absolute top-[10%] left-1/2 -translate-x-1/2">
//   <SangatiCard />
// </div>

import React from "react";
import { useTranslation } from "react-i18next";
import VolIcon from "../icons/vol.svg?react";

interface SangatiCardProps {
  className?: string;
}

const SangatiCard: React.FC<SangatiCardProps> = ({ className = "" }) => {
  const { t } = useTranslation();

  return (
    <div
      className={`
        relative
        min-w-[235px]
        max-w-[350px]
        px-8 sm:px-10
        py-3 sm:py-4
        mx-auto
        flex flex-col items-center
        rounded-xl
        bg-bg-grey
        cursor-pointer
        focus:outline-none focus:ring-2 focus:ring-[#105142] focus:ring-offset-2
        hover:shadow-lg hover:scale-[1.02]
        active:scale-[0.98]
        transition-all duration-200
        box-border
        ${className}
      `}
      role="button"
      tabIndex={0}
      aria-label={t("playAudio")}
    >
      {/* Border elements */}
      <div className="absolute left-0 top-0 w-[calc(50%-2px)] h-full border-2 border-r-0 border-black/20 rounded-l-xl" />
      <div className="absolute right-0 top-0 w-[calc(50%-2px)] h-full border-2 border-l-0 border-black/20 rounded-r-xl" />

      <div className="text-16 font-bold text-sangati-green text-center uppercase">
        <h2>Share Your</h2>
      </div>

      <div className="font-bold text-6xl text-center max-w-xs sm:max-w-sm bg-gradient-soul gradient-text uppercase">
        <p>SOUL</p>
      </div>

      <div className="py-3">
        <VolIcon
          width={30}
          height={30}
          className="cursor-pointer pulse-audio text-neutral-dark-grey"
        />
      </div>

      <div className="text-16 text-sangati-green text-center">
        <p>uncover your self<br />
          discover your match</p>
      </div>
    </div >
  );
};

export default SangatiCard;
